module.exports = __webpack_public_path__ + "static/media/gc-chapter-2.dcceabee.png";